import fetch from '@/plugin/axios'

// 查询列表
export function getOrderList (query) {
  return fetch({
    url: '/api/order/order/list',
    method: 'Post',
    data: query
  })
}

// 详情列表
export function getDetailList (query) {
  return fetch({
    url: '/api/order/order/info/' + query,
    method: 'Get'
  })
}

// 退款
export function getRefund (query) {
  return fetch({
    url: '/api/order/order/refund',
    method: 'Post',
    data: query
  })
}

// 客服备注
export function getCuserRemark (id, query) {
  return fetch({
    url: '/api/order/order/remark/' + id,
    method: 'Post',
    headers: {
      'Content-Type': 'application/json'
    },
    data: query
  })
}

// 发货
export function getShip (query) {
  return fetch({
    url: '/api/order/order/deliver',
    method: 'Post',
    data: query
  })
}

// 物流状态列表
export function getExpressLists (id) {
  return fetch({
    url: '/api/order/order/express/' + id,
    method: 'Get'
  })
}

// 物流动态详情
export function getExpressDetail (id) {
  return fetch({
    url: '/api/order/order/express/info/' + id,
    method: 'Get'
  })
}

// 订单导出
export function getExport (obj) {
  return fetch({
    url: '/api/order/order/export',
    method: 'post',
    data: obj,
    responseType: 'blob'
  })
}
